import React, { useState } from "react";
import {
  Box,
  IconButton,
  SvgIcon,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import store from "../../store";
import LikeIcon from "../../assets/icons/like-icon-small.svg";
import LikedIcon from "../../assets/icons/liked-icon-small.svg";
import { ReactComponent as NoImgIcon } from "../../assets/icons/no-img-icon.svg";
import "./image-carousel.scss";

export default function ImageCarouselWithOverlay({
  images,
  avgRating,
  businessType,
  isFavorite,
  onFavoriteToggle,
  showFavoriteIcon,
}: any) {

  const [currentIndex, setCurrentIndex] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isLoggedIn = store.getState()?.session?.isLoggedIn || false;

  const hasImages = images && images.length > 0;

  if (!hasImages) {
    return (
      <Box
        className="carousel-container"
        sx={{
          color: "#777",
          background: "#F9FAFC",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        {" "}
        <SvgIcon
          component={NoImgIcon}
          style={{
            height: "48px",
            width: "48px",
          }}
          inheritViewBox
        />
        <Typography>No Image Available</Typography>
      </Box>
    );
  }

  const handleNext = () => {
    if (currentIndex < images.length - 1) {
      setCurrentIndex((prev) => prev + 1);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prev) => prev - 1);
    }
  };

  return (
    <Box className="carousel-container">
      <Box className="image-container-box">
        {images[currentIndex]?.mediaType === "video" ? (
          <video
            src={images[currentIndex]?.url}
            className="carousel-image"
            controls
            autoPlay
            muted
            loop
            playsInline
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          />
        ) : (
          <img
            src={images[currentIndex]?.url}
            alt={`carousel-img-${currentIndex}`}
            className="carousel-image"
          />
        )}
      </Box>

      {/* Top-left: Rating */}
      {avgRating > 0 && (
        <Box className="overlay top-left" display="flex" alignItems="center" gap="4px">
          <StarRoundedIcon
            fontSize="small"
            sx={{ color: "#e9ae10" }}
          />
          <Typography variant="body2">
            {avgRating.toFixed(1)}
          </Typography>
        </Box>
      )}

      {/* Provider type title */}
      <Box className="overlay top-left-provider">
        <Typography
          variant="body2"
          sx={{
            fontWeight: 500,
          }}
        >
          {businessType}
        </Typography>
      </Box>

      {/* Top-right: Favorite */}
      {/* {isLoggedIn && showFavoriteIcon && (
        <>
          {isFavorite ? (
            <Box
              className="overlay top-right"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgba(255, 255, 255, 1)",
                borderRadius: "8px !important",
                width: "25px",
                height: "25px",
                padding: "3px 2px 2px 3px",
              }}
            >
              <IconButton onClick={onFavoriteToggle}>
                <img src={LikedIcon} alt="wishlist icon" />
              </IconButton>
            </Box>
          ) : (
            <Box
              className="overlay top-right"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgba(0, 0, 0, 0.4)",
                borderRadius: "50%",
                width: "25px",
                height: "25px",
                padding: "2px",
              }}
            >
              <IconButton onClick={onFavoriteToggle}>
                <img src={LikeIcon} alt="wishlist icon" />
              </IconButton>
            </Box>
          )}
        </>
      )} */}

      {/* Bottom-left: Previous */}
      <Box className="overlay bottom-left">
        <IconButton
          onClick={handlePrev}
          size="small"
          disabled={currentIndex === 0}
          className={`bottom-left__btn ${currentIndex === 0 ? "bottom-left__btn--disabled" : ""}`}
          sx={{ padding: "2px" }}
        >
          {isMobile ? <ArrowBackIosIcon /> : <ChevronLeftIcon />}
        </IconButton>
      </Box>

      {/* Image count */}
      <Box className="overlay bottom-right-img-count">
        <Typography className="bottom-right-image-count-text">
          {currentIndex + 1} of {images?.length}
        </Typography>
      </Box>

      {/* Bottom-right: Next */}
      <Box className="overlay bottom-right">
        <IconButton
          onClick={handleNext}
          size="small"
          disabled={currentIndex === images?.length - 1}
          className={`bottom-right__btn ${currentIndex === images?.length - 1 ? "bottom-right__btn--disabled" : ""}`}
          sx={{ padding: "2px" }}
        >
          {isMobile ? <ArrowForwardIosIcon /> : <ChevronRightIcon />}
        </IconButton>
      </Box>
    </Box>
  );
}
